import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-sing',
  templateUrl: './auth-sing.component.html',
  styleUrls: ['./auth-sing.component.scss']
})
export class AuthSingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
